import template from './campaign-list.html';
import controller from './campaign-list.controller';

let campaignListComponent = {
  bindings: {},
  template,
  controller
};

export default campaignListComponent;



// WEBPACK FOOTER //
// ./client/app/components/campaign/campaign-list.component.js